import React from "react";
import styled from 'styled-components'

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-cube";
import "swiper/css/pagination";
import { EffectCube, Pagination } from "swiper";

import beachParty from '../assets/party1.jpg'
import event5 from '../assets/event5.jpg'
import event6 from '../assets/event6.jpg'
import beacheConcert from '../assets/beachconcert1.jpg'


import asdf from '../assets/events/event6.webp'

const Container = styled.div`
width: auto;
height: auto;

.swiper{
  width: 300px;
  height: 300px;
  position: absolute;
  right: 5%;
  top: -15%;

  img{
    width: 300px;
  height: 300px;
  }
}

.swiper-slide {
  background-position: center;
  background-size: cover;
}

.swiper-slide img {
  display: block;
  width: 100%;
}
`

const AccomCube = () => {
  return (
    <Container>
    <Swiper
      effect={"cube"}
      grabCursor={true}
      cubeEffect={{
        shadow: true,
        slideShadows: true,
        shadowOffset: 20,
        shadowScale: 0.94,
      }}
      pagination={true}
      modules={[EffectCube, Pagination]}
      className="mySwiper"
    >
      <SwiperSlide>
        <img src={asdf} alt="accomo1" />
      </SwiperSlide>
      <SwiperSlide>
        <img src={event6} alt="accomo2" />
      </SwiperSlide>
      <SwiperSlide>
        <img src={beachParty} alt="accomo3" />
      </SwiperSlide>
      <SwiperSlide>
        <img src={beacheConcert} alt="accomo4" />
      </SwiperSlide>
    </Swiper>
  </Container>
  )
}

export default AccomCube